import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "d2f021523a6cbb226c4423a4d363498d.jpg","uri@2x": __webpack_public_path__ + "0f539e46acd81d14efc2a198f644ce4b.jpg","uri@3x": __webpack_public_path__ + "195d4e52d335b47669e14e824be75fda.jpg",
    width: 1024,
    height: 550
});